import React, { useState, useEffect } from "react";

import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TablePagination from "@mui/material/TablePagination";

import ListTituloGrupoTable from "./TableTituloGrupo/index";
import { retrieveTituloGrupo } from "../../../../../services/frontCredito/index";

import { toast } from "react-toastify";

import { CardWrapper, Label, Card, RodaPe, Text } from "../../styles";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const TituloGrupoComponent = (props) => {
  const classes = useStyles();

  const [logs, setLogs] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    cpfCnpj: props.cpfCnpj,
    pageable: {
      page: 0,
      size: 10,
      sortColumn: null,
      sortDirection: "ASC",
    },
  });

  useEffect(() => {
    getDataByFilters(filters);
  }, [filters]);

  const handleChangePage = (p, newPage) => {
    setFilters({
      ...filters,
      pageable: {
        ...filters.pageable,
        page: newPage,
      },
    });
  };

  async function getDataByFilters(filters) {
    setIsLoading(true);
    setLogs([]);
    setTotalElements(0);

    retrieveTituloGrupo(filters)
      .then((response) => {
        if (response && (response.status === 201 || response.status === 200)) {
          const {
            data: { content, total },
          } = response;

          setLogs(content);
          setTotalElements(total);
        } else if (!response) {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados.");
        }
      })
      .finally(() => setIsLoading(false));
  }

  return (
    <CardWrapper>
      <Label>Atrasos</Label>
      {totalElements == 0 && isLoading == false ? (
        <Card>
          <Text>SEM DADOS.</Text>
        </Card>
      ) : (
        <Card>
          <Grid item md={12}>
            <ListTituloGrupoTable logs={logs} isLoading={isLoading} />
          </Grid>
          <Grid item md={12}>
            <RodaPe>
              <TablePagination
                component="div"
                classes={{
                  toolbar: classes.toolbar,
                  caption: classes.caption,
                }}
                count={totalElements}
                page={filters.pageable.page || 0}
                labelDisplayedRows={({ from, to, count }) =>
                  `${from} - ${to} de ${count}`
                }
                onPageChange={handleChangePage}
                rowsPerPageOptions={[]}
                rowsPerPage={filters.pageable.size}
              />
            </RodaPe>
          </Grid>
        </Card>
      )}
    </CardWrapper>
  );
};

export default TituloGrupoComponent;
